<div class="button" [ngClass]="[working ? 'working' : stateClass, type]" (click)="parseClick($event)">
    {{ showSaved() ? labelSaved : working && progression ? ('submit-button.progression' | translate: progression) : label }}
</div>
